import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import { copyFor } from 'config';
import { useAdvocacyContext } from 'contexts/advocacy';
import { StyledText } from '../message.style';

const getCopy = copyFor('advocacy.message.representatives');

export const Representatives = () => {
  const { representatives } = useAdvocacyContext();
  if (!representatives) return null;
  return (
    <Container>
      <Text textStyle="heading500" tag="h2">
        {getCopy('title')}
      </Text>
      <Container flex direction="column" width="100%">
        {representatives.map(rep => (
          <Container
            key={rep.name}
            flex
            direction="column"
            alignItems="left"
            margin={{ top: '16px' }}
          >
            <Text className="notranslate" textStyle="paragraph400">
              {rep.name}
            </Text>
            <StyledText className="notranslate" textStyle="paragraph400">
              {rep.title}
            </StyledText>
          </Container>
        ))}
      </Container>
    </Container>
  );
};
